<template>
    <v-row justify="center" class="ma-n1">
        <v-col cols="auto" class="pa-1">
            <v-btn outlined width="150" :color="form.interview.isOnline == true ? 'primary' : 'grey-d'" @click="emit(true)">
                <span :class="{ 'grey--text': form.interview.isOnline != true }"> 온라인 </span>
            </v-btn>
        </v-col>
        <v-col cols="auto" class="pa-1">
            <v-btn outlined width="150" :color="form.interview.isOnline != true ? 'primary' : 'grey-d'" @click="emit(false)">
                <span :class="{ 'grey--text': form.interview.isOnline == true }"> 오프라인 </span>
            </v-btn>
        </v-col>
    </v-row>
</template>

<script>
import { initExpoEmployer } from "@/assets/variables/inits";

export default {
    props: {
        value: { type: Object, default: initExpoEmployer }, // form
    },
    data: () => ({
        form: initExpoEmployer(),
    }),
    methods: {
        sync() {
            this.form = initExpoEmployer(this.value);
        },
        emit(isOnline) {
            this.form.interview.isOnline = isOnline;
            this.$emit("input", this.form);
        },
    },
    watch: {
        value() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>
